import _ from "lodash";
import { getEnabledElement } from "component/toolManager/enabledElements.js";
/**
 *
 */
function getTransform(enabledElement) {
  // 추후 가속화를 위해 매번 변형 매트릭스를 구하지 않고
  // 캐싱 후 사용 하도록 변경 필요
  return calculateTransform(enabledElement);
}

function getTransformExt(enabledElement, ignoreTranslation = false) {
  // 추후 가속화를 위해 매번 변형 매트릭스를 구하지 않고
  // 캐싱 후 사용 하도록 변경 필요
  return calculateTransformExt(enabledElement, ignoreTranslation);
}

function getTransformPure(canvas, viewport, pixelSpacing) {
  // 추후 가속화를 위해 매번 변형 매트릭스를 구하지 않고
  // 캐싱 후 사용 하도록 변경 필요
  return calculateTransformPure(canvas, viewport, pixelSpacing);
}

function calculateTransformExt(enabledElement, scale) {
  // 추후 가속화를 위해 매번 변형 매트릭스를 구하지 않고
  // 캐싱 후 사용 하도록 변경 필요

  const transform = new Transform();
  let angle = 0;
  try {
    // Move to center of canvas
    transform.translate(
      enabledElement.canvas.width / 2,
      enabledElement.canvas.height / 2
    );

    // Apply the rotation before scaling for non square pixels
    //const angle = enabledElement.viewport.rotation;
    angle = enabledElement.viewport.rotation;
  } catch (err) {
    //console.log("error ");
  }

  if (angle !== 0) {
    transform.rotate((angle * Math.PI) / 180);
  }

  if (_.get(enabledElement, "viewport") === undefined) {
    // 임시방편
    enabledElement = getEnabledElement(enabledElement);
  }

  // Apply the scale
  let widthScale = 1;
  let heightScale = 1;

  const width =
    enabledElement.viewport.displayedArea.brhc.x -
    (enabledElement.viewport.displayedArea.tlhc.x - 1);
  const height =
    enabledElement.viewport.displayedArea.brhc.y -
    (enabledElement.viewport.displayedArea.tlhc.y - 1);

  let rowPixelSpacing = 1.0;
  let columnPixelSpacing = 1.0;

  if (
    _.get(enabledElement, "image.pixelSpacing[0]") &&
    _.get(enabledElement, "image.pixelSpacing[0]")
  ) {
    rowPixelSpacing = enabledElement.image.pixelSpacing[0] || 1.0;
    columnPixelSpacing = enabledElement.image.pixelSpacing[1] || 1.0;
  }
  if (enabledElement.viewport.displayedArea.presentationSizeMode === "NONE") {
    if (rowPixelSpacing < columnPixelSpacing) {
      widthScale *= columnPixelSpacing / rowPixelSpacing;
    } else if (columnPixelSpacing < rowPixelSpacing) {
      heightScale *= rowPixelSpacing / columnPixelSpacing;
    }
  } else {
    // These should be good for "TRUE SIZE" and "MAGNIFY"
    widthScale = enabledElement.viewport.displayedArea.columnPixelSpacing;
    heightScale = enabledElement.viewport.displayedArea.rowPixelSpacing;

    if (
      enabledElement.viewport.displayedArea.presentationSizeMode ===
      "SCALE TO FIT"
    ) {
      // Fit TRUE IMAGE image (width/height) to window
      const verticalScale =
        enabledElement.canvas.height / (height * heightScale);
      const horizontalScale =
        enabledElement.canvas.width / (width * widthScale);

      // Apply new scale
      widthScale = heightScale = Math.min(horizontalScale, verticalScale);

      if (
        enabledElement.viewport.displayedArea.rowPixelSpacing <
        enabledElement.viewport.displayedArea.columnPixelSpacing
      ) {
        widthScale *=
          enabledElement.viewport.displayedArea.columnPixelSpacing /
          enabledElement.viewport.displayedArea.rowPixelSpacing;
      } else if (
        enabledElement.viewport.displayedArea.columnPixelSpacing <
        enabledElement.viewport.displayedArea.rowPixelSpacing
      ) {
        heightScale *=
          enabledElement.viewport.displayedArea.rowPixelSpacing /
          enabledElement.viewport.displayedArea.columnPixelSpacing;
      }
    }
  }

  transform.scale(widthScale, heightScale);

  // Unrotate to so we can translate unrotated
  if (angle !== 0) {
    transform.rotate((-angle * Math.PI) / 180);
  }
  transform.translate(0, 0);

  // Rotate again so we can apply general scale
  if (angle !== 0) {
    transform.rotate((angle * Math.PI) / 180);
  }

  if (scale !== undefined) {
    // Apply the font scale
    transform.scale(scale, scale);
  }

  // Apply Flip if required
  if (enabledElement.viewport.hflip) {
    transform.scale(-1, 1);
  }

  if (enabledElement.viewport.vflip) {
    transform.scale(1, -1);
  }

  // Move back from center of image
  transform.translate(-width / 2, -height / 2);

  return transform;
}

/**
 * Calculate the transform for a  enabled element
 *
 * @param {EnabledElement} enabledElement The  Enabled Element
 * @param {Number} [scale] The viewport scale
 * @return {Transform} The current transform
 * @memberof Internal
 */
function calculateTransform(enabledElement, scale) {
  // For now we will calculate it every time it is requested.
  // In the future, we may want to cache it in the enabled element to speed things up.

  const transform = new Transform();
  let angle = 0;
  try {
    // Move to center of canvas
    transform.translate(
      enabledElement.canvas.width / 2,
      enabledElement.canvas.height / 2
    );

    // Apply the rotation before scaling for non square pixels
    //const angle = enabledElement.viewport.rotation;
    angle = enabledElement.viewport.rotation;
  } catch (err) {
    //console.log("error ");
  }

  if (angle !== 0) {
    transform.rotate((angle * Math.PI) / 180);
  }

  if (_.get(enabledElement, "viewport") === undefined) {
    // 임시방편
    enabledElement = getEnabledElement(enabledElement);
  }

  // Apply the scale
  let widthScale = enabledElement.viewport.scale;
  let heightScale = enabledElement.viewport.scale;

  const width =
    enabledElement.viewport.displayedArea.brhc.x -
    (enabledElement.viewport.displayedArea.tlhc.x - 1);
  const height =
    enabledElement.viewport.displayedArea.brhc.y -
    (enabledElement.viewport.displayedArea.tlhc.y - 1);

  let rowPixelSpacing = 1.0;
  let columnPixelSpacing = 1.0;

  if (
    _.get(enabledElement, "image.pixelSpacing[0]") &&
    _.get(enabledElement, "image.pixelSpacing[0]")
  ) {
    rowPixelSpacing = enabledElement.image.pixelSpacing[0] || 1.0;
    columnPixelSpacing = enabledElement.image.pixelSpacing[1] || 1.0;
  }
  if (enabledElement.viewport.displayedArea.presentationSizeMode === "NONE") {
    if (rowPixelSpacing < columnPixelSpacing) {
      widthScale *= columnPixelSpacing / rowPixelSpacing;
    } else if (columnPixelSpacing < rowPixelSpacing) {
      heightScale *= rowPixelSpacing / columnPixelSpacing;
    }
  } else {
    // These should be good for "TRUE SIZE" and "MAGNIFY"
    widthScale = enabledElement.viewport.displayedArea.columnPixelSpacing;
    heightScale = enabledElement.viewport.displayedArea.rowPixelSpacing;

    if (
      enabledElement.viewport.displayedArea.presentationSizeMode ===
      "SCALE TO FIT"
    ) {
      // Fit TRUE IMAGE image (width/height) to window
      const verticalScale =
        enabledElement.canvas.height / (height * heightScale);
      const horizontalScale =
        enabledElement.canvas.width / (width * widthScale);

      // Apply new scale
      widthScale = heightScale = Math.min(horizontalScale, verticalScale);

      if (
        enabledElement.viewport.displayedArea.rowPixelSpacing <
        enabledElement.viewport.displayedArea.columnPixelSpacing
      ) {
        widthScale *=
          enabledElement.viewport.displayedArea.columnPixelSpacing /
          enabledElement.viewport.displayedArea.rowPixelSpacing;
      } else if (
        enabledElement.viewport.displayedArea.columnPixelSpacing <
        enabledElement.viewport.displayedArea.rowPixelSpacing
      ) {
        heightScale *=
          enabledElement.viewport.displayedArea.rowPixelSpacing /
          enabledElement.viewport.displayedArea.columnPixelSpacing;
      }
    }
  }

  transform.scale(widthScale, heightScale);

  // Unrotate to so we can translate unrotated
  if (angle !== 0) {
    transform.rotate((-angle * Math.PI) / 180);
  }
  // Apply the pan offset
  transform.translate(
    enabledElement.viewport.translation.x,
    enabledElement.viewport.translation.y
  );

  // Rotate again so we can apply general scale
  if (angle !== 0) {
    transform.rotate((angle * Math.PI) / 180);
  }

  if (scale !== undefined) {
    // Apply the font scale
    transform.scale(scale, scale);
  }

  // Apply Flip if required
  if (enabledElement.viewport.hflip) {
    transform.scale(-1, 1);
  }

  if (enabledElement.viewport.vflip) {
    transform.scale(1, -1);
  }

  // Move back from center of image
  transform.translate(-width / 2, -height / 2);

  return transform;
}
/**
 * Calculate the transform for a  enabled element
 *
 * @param {EnabledElement} enabledElement The  Enabled Element
 * @param {Number} [scale] The viewport scale
 * @return {Transform} The current transform
 * @memberof Internal
 */
function calculateTransformPure(canvas, viewport, pixelSpacing, scale) {
  // For now we will calculate it every time it is requested.
  // In the future, we may want to cache it in the enabled element to speed things up.

  const transform = new Transform();
  let angle = 0;
  try {
    // Move to center of canvas
    transform.translate(canvas.width / 2, canvas.height / 2);

    // Apply the rotation before scaling for non square pixels
    angle = viewport.rotation;
  } catch (err) {
    //console.log("error ");
  }

  if (angle !== 0) {
    transform.rotate((angle * Math.PI) / 180);
  }

  // Apply the scale
  let widthScale = viewport.scale;
  let heightScale = viewport.scale;

  const width =
    viewport.displayedArea.brhc.x - (viewport.displayedArea.tlhc.x - 1);
  const height =
    viewport.displayedArea.brhc.y - (viewport.displayedArea.tlhc.y - 1);

  let rowPixelSpacing = pixelSpacing[0] || 1.0;
  let columnPixelSpacing = pixelSpacing[1] || 1.0;

  if (viewport.displayedArea.presentationSizeMode === "NONE") {
    if (rowPixelSpacing < columnPixelSpacing) {
      widthScale *= columnPixelSpacing / rowPixelSpacing;
    } else if (columnPixelSpacing < rowPixelSpacing) {
      heightScale *= rowPixelSpacing / columnPixelSpacing;
    }
  } else {
    // These should be good for "TRUE SIZE" and "MAGNIFY"
    widthScale = viewport.displayedArea.columnPixelSpacing;
    heightScale = viewport.displayedArea.rowPixelSpacing;

    if (viewport.displayedArea.presentationSizeMode === "SCALE TO FIT") {
      // Fit TRUE IMAGE image (width/height) to window
      const verticalScale = canvas.height / (height * heightScale);
      const horizontalScale = canvas.width / (width * widthScale);

      // Apply new scale
      widthScale = heightScale = Math.min(horizontalScale, verticalScale);

      if (
        viewport.displayedArea.rowPixelSpacing <
        viewport.displayedArea.columnPixelSpacing
      ) {
        widthScale *=
          viewport.displayedArea.columnPixelSpacing /
          viewport.displayedArea.rowPixelSpacing;
      } else if (
        viewport.displayedArea.columnPixelSpacing <
        viewport.displayedArea.rowPixelSpacing
      ) {
        heightScale *=
          viewport.displayedArea.rowPixelSpacing /
          viewport.displayedArea.columnPixelSpacing;
      }
    }
  }

  transform.scale(widthScale, heightScale);

  // Unrotate to so we can translate unrotated
  if (angle !== 0) {
    transform.rotate((-angle * Math.PI) / 180);
  }
  // Apply the pan offset
  transform.translate(viewport.translation.x, viewport.translation.y);

  // Rotate again so we can apply general scale
  if (angle !== 0) {
    transform.rotate((angle * Math.PI) / 180);
  }

  if (scale !== undefined) {
    // Apply the font scale
    transform.scale(scale, scale);
  }

  // Apply Flip if required
  if (viewport.hflip) {
    transform.scale(-1, 1);
  }

  if (viewport.vflip) {
    transform.scale(1, -1);
  }

  // Move back from center of image
  transform.translate(-width / 2, -height / 2);

  return transform;
}
// By Simon Sarris
// Www.simonsarris.com
// Sarris@acm.org
//
// Free to use and distribute at will
// So long as you are nice to people, etc

// Simple class for keeping track of the current transformation matrix

// For instance:
//    Var t = new Transform();
//    T.rotate(5);
//    Var m = t.m;
//    Ctx.setTransform(m[0], m[1], m[2], m[3], m[4], m[5]);

// Is equivalent to:
//    Ctx.rotate(5);

// But now you can retrieve it :)

// Remember that this does not account for any CSS transforms applied to the canvas
class Transform {
  constructor() {
    this.reset();
  }

  reset() {
    this.m = [1, 0, 0, 1, 0, 0];
  }

  clone() {
    const transform = new Transform();

    transform.m[0] = this.m[0];
    transform.m[1] = this.m[1];
    transform.m[2] = this.m[2];
    transform.m[3] = this.m[3];
    transform.m[4] = this.m[4];
    transform.m[5] = this.m[5];

    return transform;
  }

  multiply(matrix) {
    const m11 = this.m[0] * matrix.m[0] + this.m[2] * matrix.m[1];
    const m12 = this.m[1] * matrix.m[0] + this.m[3] * matrix.m[1];

    const m21 = this.m[0] * matrix.m[2] + this.m[2] * matrix.m[3];
    const m22 = this.m[1] * matrix.m[2] + this.m[3] * matrix.m[3];

    const dx = this.m[0] * matrix.m[4] + this.m[2] * matrix.m[5] + this.m[4];
    const dy = this.m[1] * matrix.m[4] + this.m[3] * matrix.m[5] + this.m[5];

    this.m[0] = m11;
    this.m[1] = m12;
    this.m[2] = m21;
    this.m[3] = m22;
    this.m[4] = dx;
    this.m[5] = dy;
  }

  invert() {
    const d = 1 / (this.m[0] * this.m[3] - this.m[1] * this.m[2]);
    const m0 = this.m[3] * d;
    const m1 = -this.m[1] * d;
    const m2 = -this.m[2] * d;
    const m3 = this.m[0] * d;
    const m4 = d * (this.m[2] * this.m[5] - this.m[3] * this.m[4]);
    const m5 = d * (this.m[1] * this.m[4] - this.m[0] * this.m[5]);

    this.m[0] = m0;
    this.m[1] = m1;
    this.m[2] = m2;
    this.m[3] = m3;
    this.m[4] = m4;
    this.m[5] = m5;
  }

  rotate(rad) {
    const c = Math.cos(rad);
    const s = Math.sin(rad);
    const m11 = this.m[0] * c + this.m[2] * s;
    const m12 = this.m[1] * c + this.m[3] * s;
    const m21 = this.m[0] * -s + this.m[2] * c;
    const m22 = this.m[1] * -s + this.m[3] * c;

    this.m[0] = m11;
    this.m[1] = m12;
    this.m[2] = m21;
    this.m[3] = m22;
  }

  translate(x, y) {
    this.m[4] += this.m[0] * x + this.m[2] * y;
    this.m[5] += this.m[1] * x + this.m[3] * y;
  }

  scale(sx, sy) {
    this.m[0] *= sx;
    this.m[1] *= sx;
    this.m[2] *= sy;
    this.m[3] *= sy;
  }

  transformPoint(px, py) {
    const x = px;
    const y = py;

    px = x * this.m[0] + y * this.m[2] + this.m[4];
    py = x * this.m[1] + y * this.m[3] + this.m[5];

    return {
      x: px,
      y: py,
    };
  }
}

export {
  calculateTransform,
  calculateTransformPure,
  Transform,
  getTransform,
  getTransformExt,
  getTransformPure,
};

// export { projectPatientPointToImagePlane,
//   imagePointToPatientPoint,
//   lineRectangleIntersection } from './common.math.transform.projection.js'
